"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image360PreviewItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _Icon = require("b2b-components/theme/components/Icon");
var _Item = require("../Item");
var _ItemIcon = require("../ItemIcon");
var _ItemImage = require("../ItemImage");
const Image360PreviewItem = _ref => {
  let {
    image360,
    imageUrl,
    title,
    className,
    isPreview,
    imageDisclaimer
  } = _ref;
  const imageSrc = `${imageUrl}${image360.base[0]}`;
  return /*#__PURE__*/_react.default.createElement(_Item.Item, {
    className: className,
    isPreview: isPreview,
    href: imageSrc,
    type: _Gallery.GALLERY_ITEM_TYPE.image360,
    imageDisclaimer: imageDisclaimer
  }, /*#__PURE__*/_react.default.createElement(_ItemImage.ItemImage, {
    src: imageSrc,
    title: title
  }), /*#__PURE__*/_react.default.createElement(_ItemIcon.ItemIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.rotate360
  })));
};
exports.Image360PreviewItem = Image360PreviewItem;
//# sourceMappingURL=Image360PreviewItem.js.map